(() => {
  const normalize = (text) => text.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().trim();
  const resolveURL = (value) => {
    try {
      const url = new URL(value, document.baseURI);
      if (!['http:', 'https:'].includes(url.protocol)) return null;
      url.hash = '';
      return url.href;
    } catch {
      return null;
    }
  };
  const initialize = (product) => {
    const region = product.querySelector('[data-rc-documents]');
    const list = region?.querySelector('[data-rc-document-links]');
    if (!region || !list || region.dataset.initialized === 'true') return;
    region.dataset.initialized = 'true';
    const uploadedSheetURL = region.dataset.sheetFileUrl ? resolveURL(region.dataset.sheetFileUrl) : null;
    const uploadedManualURL = region.dataset.manualFileUrl ? resolveURL(region.dataset.manualFileUrl) : null;
    const urls = new Set();
    for (const link of list.querySelectorAll('a[href]')) {
      const url = resolveURL(link.getAttribute('href'));
      if (!url || urls.has(url)) link.remove();
      else urls.add(url);
    }
    for (const source of product.querySelectorAll('[data-rc-document-source]')) {
      for (const link of [...source.querySelectorAll('a[href]')]) {
        const url = resolveURL(link.getAttribute('href'));
        if (!url) continue;
        const text = normalize(link.textContent);
        const sheet = /produktblad|datablad|datasheet|data sheet|product sheet/.test(text);
        const manual = /manual|bruksanvisning|instruction/.test(text);
        const drawing = /mattritning|drawing|ritning|dimension/.test(text);
        if (!sheet && !manual && !drawing && !/\.pdf(?:[?#]|$)|[?&]controller=attachment(?:&|$)/i.test(url)) continue;
        const replacedSheet = sheet && uploadedSheetURL;
        const replacedManual = manual && !sheet && !drawing && uploadedManualURL;
        if (!replacedSheet && !replacedManual && !urls.has(url)) {
          const label = sheet ? region.dataset.sheetLabel
            : manual ? region.dataset.manualLabel
              : drawing ? region.dataset.drawingLabel
                : link.textContent.trim() || region.dataset.documentLabel;
          const card = document.createElement('a');
          card.className = 'rc-product__document-card';
          card.href = url;
          card.target = '_blank';
          card.rel = 'noopener noreferrer';
          card.setAttribute('aria-label', label + ' — ' + region.dataset.newTabLabel);
          const icon = document.createElement('span');
          icon.className = 'rc-product__document-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<svg viewBox="0 0 24 28" fill="none"><path d="M4 1h10l7 7v18H4z" stroke="currentColor" stroke-width="1.5"/><path d="M14 1v7h7M8 14h9M8 18h9M8 22h5" stroke="currentColor" stroke-width="1.5"/></svg>';
          const copy = document.createElement('span');
          copy.className = 'rc-product__document-copy';
          const title = document.createElement('strong');
          title.textContent = label;
          const hint = document.createElement('span');
          hint.textContent = region.dataset.openLabel;
          copy.append(title, hint);
          const arrow = document.createElement('span');
          arrow.className = 'rc-product__document-arrow';
          arrow.textContent = '↗';
          arrow.setAttribute('aria-hidden', 'true');
          card.append(icon, copy, arrow);
          list.append(card);
          urls.add(url);
        }
        let removable = link;
        while (removable.parentElement && removable.parentElement !== source) {
          const parent = removable.parentElement;
          if (!/^(P|LI|H[1-6]|SPAN|STRONG|EM|B|I)$/.test(parent.tagName)) break;
          if (normalize(parent.textContent) !== text || parent.querySelector('img,video,iframe,table')) break;
          removable = parent;
        }
        removable.remove();
      }
      for (const node of [...source.querySelectorAll('p,ul,ol,h2,h3,h4,h5,h6')].reverse()) {
        if (!node.textContent.trim() && !node.querySelector('img,video,iframe,table')) node.remove();
      }
      if (!source.textContent.trim() && !source.querySelector('img,video,iframe,table')) source.hidden = true;
    }
    region.hidden = !list.querySelector('a[href]');
  };
  const scan = (scope) => {
    if (scope.matches?.('rc-product')) initialize(scope);
    scope.querySelectorAll('rc-product').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
